<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2022-12-03 13:07:27
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-02-22 16:21:36
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/supplierManagement/components/baseInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--  -->
<template>
  <div class="contents">
    <div class="head-title">企业资质信息</div>
    <div class="info-wrap">
      <div>
        <div class="floor left">
          <ul>
            <li>
              <span class="item">机关类型:</span
              ><span class="item-1">{{
                companyDetailInfo.organizationTypeDisp
              }}</span>
            </li>
            <li>
              <span class="item">注册资本:</span
              ><span class="item-1">{{ companyInfo.registeredCapital }}</span>
            </li>
            <li>
              <span class="item">成立日期:</span
              ><span class="item-1">{{ companyInfo.regYear }}</span>
            </li>
          </ul>
        </div>
        <div class="floor middle">
          <ul>
            <li>
              <span class="item">企业性质:</span
              ><span class="item-1">{{
                companyDetailInfo.economicpropertydisp
              }}</span>
            </li>
            <li>
              <span class="item">法务代表人:</span
              ><span class="item-1">{{ companyInfo.legalRepresentative }}</span>
            </li>
            <li>
              <span class="item">经营地址:</span
              ><span class="item-1">{{ companyDetailInfo.regCity }}</span>
            </li>
          </ul>
        </div>
        <div class="floor right">
          <ul>
            <li>
              <span class="item">行政区域:</span
              ><span class="item-1">{{ companyDetailInfo.provinceName+ companyDetailInfo.cityName+companyDetailInfo.districtName}}</span>
            </li>
            <li>
              <span class="item">行业分类:</span
              ><span class="item-1">{{
                companyDetailInfo.industryclassificationDisp
              }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div>
        <p class="floor-1-title">经营范围</p>
        <p class="info-txt">{{ companyInfo.businessScope }}</p>
      </div>
      <p class="floor-2-title">公司简介</p>
      <p class="info-txt info-txt-margin">
      {{companyOtherInfo.companyIntroduction}}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    companyInfo: {
      type: Object,
      default() {
        return {};
      },
    },
     companyOtherInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    companyDetailInfo: {
      type: Object,
      default() {
        return {};
      },
    }
  },
  data() {
    return {};
  },

  components: {},

  computed: {},

  created() {},
  methods: {
    formatterOrganizationType(code) {
      let str = "";
      switch (code) {
        case 101:
          str = "企业";
          break;
        case 102:
          str = "事业单位/政府机关";
          break;
        case 103:
          str = "军队/部队";
          break;
        case 104:
          str = "个体户";
          break;
        case 105:
          str = "外国企业";
          break;

        default:
          str = "其他";
          break;
      }
      return str;
    },
    formatterEconomicProperty(code) {
      let str = "";
      switch (code) {
        case 101:
          str = "国有";
          break;
        case 102:
          str = "外资";
          break;
        case 103:
          str = "私营";
          break;
        case 104:
          str = "中外合资";
          break;
        case 105:
          str = "集体";
          break;
        case 106:
          str = "股份制";
          break;
        case 107:
          str = "有限责任";
          break;
        case 108:
          str = "联营";
          break;
        case 110:
          str = "股份有限公司";
          break;
        case 111:
          str = "其它";
          break;
        default:
          break;
      }
      return str;
    },
  },
};
</script>
<style lang="scss" scoped>
.contents {
  // width: 1010px;
  // margin:0 auto;
  // margin:0 auto;
  border: 1px solid #d9d9d9;
  margin-bottom: 20px;
  .head-title {
    color: #333;
    font-size: 14px;
    background: #d9d9d9;
    padding: 15px 20px;
    margin-bottom: 20px;
  }
  .info-wrap {
        padding-left: 20px;

    .company-name {
      font-size: 16px;
      color: #333;
      margin-top: 20px;
      font-weight: 500;
      margin-bottom: 20px;
    }
    & > :first-child {
      display: flex;
    }
    .floor {
      ul {
        li {
          line-height: 1;
          margin-bottom: 20px;
        }
      }
      .item {
        display: inline-block;
        color: #333;
        font-size: 14px;
        // width: 40%;
        text-align: left;
        margin-right: 10px;
      }
      .item-1 {
        color: #333;
        font-size: 14px;
      }
    }
    .left {
      width: 30%;
      ul {
        li {
          line-height: 1;
          margin-bottom: 20px;
        }
      }
      .item {
        display: inline-block;
        color: #333;
        font-size: 14px;
        // width: 40%;
        text-align: left;
        margin-right: 10px;
      }
      .item-1 {
        color: #333;
        font-size: 14px;
      }
    }
    .middle {
      width: 30%;
      p {
        font-size: 14px;
        color: #333;
      }
    }
    .right {
      width: 40%;
      p {
        font-size: 14px;
        color: #333;
      }
    }
    .floor-1-title {
      margin-top: 10px;
      font-size: 14px;
      color: #333;
      font-weight: 500;
    }
    .floor-2-title {
      margin-top: 30px;
      font-size: 14px;
      color: #333;
      font-weight: 500;
    }
    .info-txt {
      font-weight: 350;
      font-size: 14px;
      line-height: 1.2;
      margin-top: 10px;
      /* or 100% */

      /* 灰色/Gy8-#333333 */

      color: #333333;
    }
    .info-txt-margin{
      margin-bottom: 20px;
    }
  }
}
</style>
